import styled from '@emotion/styled'

import LogoCarousel from '@segment/templates/LogoCarousel'
import { carouselLogos } from '@segment/templates/LogoCarousel/data'

const logos = [carouselLogos.IBM, carouselLogos.ALLERGAN, carouselLogos.INTUIT, carouselLogos.FOX, carouselLogos.LEVIS]

const Carousel = () => {
  return (
    <Wrapper>
      <LogoCarousel logos={logos} heading="Companies using Twilio & Segment" />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-top: 40px;
  margin-bottom: 20px;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    margin-top: 60px;
    margin-bottom: 60px;
  }
`

export default Carousel
